<template>
<div class="wl-index-wrapper" v-if="association.Id" @click="isShow = false">
    <div class="wl-pc-wrapper" v-if="!isPhone">
        <div class="wl-inde-head clearfix">
            <div class="index-head-con clearfix">
                <div class="wx-logo-img-con">
                    <img :src="wlxLogo" alt class="wx-logo-img" />
                </div>
                <div class="wl-lr-content" v-if="userInfo.code < 0||userInfo.userType==1">
                    <span class="sp-lr-login fl" @click="openLogin">登录</span>
                    <span class="sp-lr-login">|</span>
                    <span class="sp-lr-login fr" @click="register">注册</span>
                </div>
                <div class="wl-success-con clearfix" @click.stop="showClick" v-else>
                    <div class="class-border">
                        <i class="wl-icon-user"></i>
                    </div>
                    <div class="wl-user-info">
                        <span>{{ userInfo.userName }}</span>
                        <span class="sp-vertical-line">|</span>
                    </div>
                    <div class="drop-down-menu-li">
                        <!-- <router-link :to="{name:'managerIndex'}">管理平台</router-link> -->
                        <router-link :to="target">管理平台</router-link>
                        <span class="sp-vertical-line">|</span>
                    </div>
                    <div class="drop-down-menu-li" @click="outLogin()">退出登录</div>
                </div>
            </div>
            <div class="wl-head-back clearfix">
                <div class="wl-head-menu clearfix">
                    <router-link :to="{ name: 'xHome' }" class="sp-link-a">网站首页</router-link>
                    <router-link :to="{ name: 'xNewsCenter' }" class="sp-link-a">新闻公告</router-link>
                    <a class="sp-link-a" href="http://sp.clppx.org.cn/index/meetRegister" target="_blank">师资培训</a>
                    <!-- <router-link :to="{ name: 'introIndex' }" class="sp-link-a">项目介绍</router-link> -->
                    <a href="javascript:void(0);" class="sp-link-a sp-link-study-center sp-big-link-a" :class="{ linkActive: activeIndex == 1 }">
                        项目介绍
                        <div class="center-link-con">
                            <router-link v-for="item in certifycateList" :key="item.id" class="link-child-li" :to="{name:'introMain',params:{certifyId:item.id}}">{{item.titleName}}</router-link>
                        </div>
                    </a>
                    <a href="javascript:void(0);" class="sp-link-a sp-link-study-center sp-big-link-a" :class="{ linkActive: activeIndex == 1 }">
                        在线学习中心
                        <div class="center-link-con">
                            <router-link :to="{ name: 'metarialCenter' }" class="link-child-li">教材中心</router-link>
                            <router-link :to="{ name: 'videoChart', params: { videoType: 'all' } }" class="link-child-li">串讲视频</router-link>
                            <a class="link-child-li" href="http://ykt.clppx.org.cn/wlykt/home" target="_blank">中物联云课堂</a>
                            <div class="link-child-li" target="_blank" @click="toMkCerfitySelect">模拟练习平台</div>
                            <a class="link-child-li" href="http://www.clppx.org.cn/assistanceStu" target="_blank">助力学子就业</a>
                        </div>
                    </a>
                    <!-- <router-link :to="{name:'themeActivity'}" class="sp-link-a">专题活动</router-link> -->
                    <router-link :to="{ name: 'certifyIndex' }" class="sp-link-a sp-big-link-a" target="_blank">证书/成绩查询</router-link>
                    <!-- <router-link :to="{name:'certifyIndex'}" class="sp-link-a" target="_blank">证书查询</router-link>
                            <router-link :to="{name:'examResultQuery'}" class="sp-link-a">考试结果查询</router-link>-->
                    <!-- <router-link :to="{ name: 'downLoad' }" class="sp-link-a sp-big-link-a">考试软件下载</router-link> -->
                    <a href="javascript:void(0);" class="sp-link-a sp-link-study-center sp-big-link-a" :class="{ linkActive: activeIndex == 1 }">
                        考试软件下载
                        <div class="center-link-con">
                            <router-link class="link-child-li" :to="{name:'downLoad',params:{type:1}}">物流管理</router-link>
                            <router-link class="link-child-li" :to="{name:'downLoad',params:{type:2}}">供应链运营</router-link>
                        </div>
                    </a>

                     <a href="javascript:void(0);" class="sp-link-a sp-link-study-center sp-big-link-a" :class="{ linkActive: activeIndex == 1 }">
                        相关平台
                        <div class="center-link-con">
                            <a class="link-child-li" href="https://vslc.ncb.edu.cn/" target="_blank">1+x在线报名平台</a>
                            <a class="link-child-li" href="http://kw.clppx.org.cn" target="_blank">1+x考务管理平台</a>
                             <div class="link-child-li" target="_blank" @click="toMkCerfitySelect">1+x模拟考核平台</div>
                        </div>
                    </a>

                    <a href="javascript:void(0);" class="sp-link-a sp-link-study-center sp-big-link-a" :class="{ linkActive: activeIndex == 1 }">
                        IFPSM证书申请
                        <div class="center-link-con">
                            <a class="link-child-li" href="javascript:void(0);" @click="schoolApplyCert">院校集体申请</a>
                            <a class="link-child-li" href="javascript:void(0);" @click="personalApplyCert">个人纸质证书申请</a>
                        </div>
                    </a>

                    <!-- <a class="sp-link-a" href="http://exam.clppx.org.cn/downLoad" target="_blank">认证考试</a> -->
                    <!-- <a class="sp-link-a" href="https://www.56ykt.com" target="_blank">物流云课堂</a> -->
                    <!-- <span class="sp-link-a" @click="enterManager" v-if="userInfo.code < 0">管理平台</span>
                    <router-link class="sp-link-a" :to="target" v-if="userInfo.code > 0">管理平台</router-link> -->
                    <router-link :to="{ name: 'aboutUs' }" class="sp-link-a">关于我们</router-link>
                    <!-- <router-link :to="{ name: 'teaTraining' }" class="sp-link-a">师资培训</router-link> -->
                    <!-- <router-link :to="{name:'committeeTable'}" class="sp-link-a">委员会委员申报</router-link> -->
                    <!-- <router-link :to="{name:'xIntro'}"
                            class="sp-link-a">物流X介绍</router-link>-->
                    <!-- <router-link :to="{name:'certifiActiv'}" class="sp-link-a">认证活动</router-link> -->
                    <!-- <router-link :to="{name:'xIntro',params:{tabIndex:0}}"
                        class="sp-link-a">物流X介绍</router-link>
                        <router-link :to="{name:'standard'}"
                        class="sp-link-a">申请标准</router-link>-->

                    <!-- <router-link :to="{name:'certifySite'}" class="sp-link-a">认证站点</router-link>
                            <router-link :to="{name:'certifLecturer'}" class="sp-link-a">培训讲师</router-link>
                            <router-link :to="{name:'certificateStu'}" class="sp-link-a">认证学员</router-link>
                            <router-link :to="{name:'learnMaterial'}" class="sp-link-a">学习资料</router-link>
                            <router-link :to="{name:'enterprise'}" class="sp-link-a">合作企业</router-link>-->
                </div>
            </div>
        </div>
        <div class="wl-home-banner-content" v-if="isShowBanner">
            <el-carousel :interval="3000" arrow="always" height="200px" :loop="true">
                <el-carousel-item v-for="(item, index) in defaultBannerImgList" :key="index">
                    <div class="banner-back-img" :style="{ backgroundImage: 'url(' + item.DocUrl + ')' }"></div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 下载提示 -->
        <!-- <div class="down-load-chrome-wrapper">
            <a class="a-down-load" href="https://sm.myapp.com/original/Browser/70.0.3538.67_chrome_installer.exe">
                <img src="../../assets/images/download-google.png" />
                <p>谷歌浏览器下载</p>
            </a>
        </div> -->

        <div class="wl-index-content-wrapper">
            <router-view></router-view>
        </div>
        <div class="wl-index-footer-content">
            <div class="index-footer-con clearfix">
                <div class="fl company-footer-info">
                    <div class="clearfix">
                        <div class="company-footer-logo-con">
                            <img :src="footerLogo" alt class="ph-footer-logo-img" />
                        </div>
                    </div>
                    <!-- <div class="btn-contacts-number clearfix"> -->
                        <p class="p-footer-1">
                            <i class="wl-icon-dingwei"></i>
                            <span class="sp-info-label">地址：北京市丰台区丽泽路16号院2号楼铭丰大厦1106室</span>
                            <i class="wl-icon-tubiao209"></i>
                                <span class="sp-info-label">邮编：100079</span>
                                <i class="wl-icon-tubiao209"></i>
                                <span class="sp-info-label">邮箱： x@clpp.org.cn</span>
                        </p>
                    <!-- </div> -->
                    <p class="p-footer-2">
                        <span>Copyright 版权所有 ©</span>
                        <span class="sp-info-label">北京中物联物流采购培训中心</span>
                        <span>备案号：</span>
                        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19032250号-1</a>
                    </p>
                </div>
                <div class="fr company-footer-code-con clearfix">
                    <!-- <div class="fl f-code-img-con">
                            <img :src="footImage" alt class="f-code-img">
                            <p class="f-code-name">中物联教育培训</p>
                            </div>-->
                    <div class="fr f-code-img-con f-code-img-con-1">
                        <img :src="footerCodeImg" alt class="f-code-img" />
                        <p class="f-code-name">中物联教育培训公众号</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 登录弹框 -->
        <newLogin :isShow="showObject"></newLogin>
        <videoLogin :isShow="videoShowObject"></videoLogin>
        <IfpsmLogin :isShow="ifpsmShowObject"></IfpsmLogin>
    </div>
    <!-- 移动端 -->
    <div class="index-phone-show" v-if="isPhone">
        <div class="ph-login-con clearfix">
            <div class="fl">欢迎访问本站!</div>
            <div class="fr clearfix" v-if="userInfo.code > 0">
                <div class="class-border fl">
                    <i class="wl-icon-user"></i>
                </div>
                <span class="fl">{{ userInfo.userName }}</span>
                <i class="wl-icon-jieshu fr" @click="outLogin"></i>
            </div>
            <div class="fr" v-if="userInfo.code < 0">
                <span class="sp-login-label" @click="toPhLogin">登录</span>
                <span class="sp-login-label" @click="toPhRegister">注册</span>
            </div>
        </div>
        <header class="phone-index-head clearfix">
            <div class="index-head-img">
                <img :src="wlxLogo" alt class="pr-logo-img" />
            </div>
            <i class="wl-icon-ego-menu" @click="openPhoneMenu"></i>
        </header>
        <!-- 菜单栏  蒙层-->
        <div class="phone-menu-wrapper" v-show="showPhoneMenu" @click="closePhoneMenu"></div>
        <!-- 菜单 -->
        <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
            <div class="phone-menu-content" v-show="showPhoneMenu">
                <div>
                    <router-link :to="{ name: 'xHome' }" @click.native="hidePhoneMenu" class="phone-link-li">网站首页</router-link>
                    <router-link :to="{ name: 'xNewsCenter' }" @click.native="hidePhoneMenu" class="phone-link-li">新闻公告</router-link>
                    <a class="phone-link-li sp-link-a" href="http://sp.clppx.org.cn/index/meetRegister">师资培训</a>
                    <router-link :to="{ name: 'introIndex' }" @click.native="hidePhoneMenu" class="phone-link-li">项目介绍</router-link>
                    <!-- <p @click="hidePhoneMenu" class="phone-link-li sp-link-a">培训站点</p>
                    <p @click="hidePhoneMenu" class="phone-link-li sp-link-a">考核站点</p> -->
                    <router-link :to="{ name: 'metarialCenter' }" @click.native="hidePhoneMenu" class="phone-link-li"><i class="wl-icon-kangyi"></i> 抗疫学习中心</router-link>
                    <a class="phone-link-li sp-link-a" href="javascript:void(0);" @click="enterExam">考试软件下载</a>
                    <span class="sp-link-a phone-link-li" @click="phManagerTip">证书/成绩查询</span>
                    <span class="sp-link-a phone-link-li" @click="phManagerTip">管理平台</span>
                    <router-link :to="{ name: 'aboutUs' }" @click.native="hidePhoneMenu" class="phone-link-li">关于我们</router-link>
                </div>
            </div>
        </transition>
        <div class="ph-home-banner-content" v-if="isShowBanner">
            <el-carousel :interval="3000" arrow="always" height="100px" :loop="true">
                <el-carousel-item v-for="(item, index) in defaultBannerImgList" :key="index">
                    <div class="banner-back-img" :style="{ backgroundImage: 'url(' + item.DocUrl + ')' }"></div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <router-view></router-view>
        <div class="ph-index-footer-content">
            <div class="index-footer-con clearfix">
                <div class="company-footer-info">
                    <!-- <div class="company-footer-logo-con">
                            <img :src="footerLogo" alt>
                            </div>-->
                    <p class="p-footer-1">
                        <i class="wl-icon-dingwei"></i>
                        <span class="sp-info-label">地址：北京市丰台区丽泽路16号院2号楼铭丰大厦1106室</span>
                    </p>
                    <p class="p-footer-2">
                        <i class="wl-icon-tubiao209"></i>
                        <span class="sp-info-label">邮编：100079</span>
                    </p>
                    <p class="p-footer-2">
                        <i class="wl-icon-tubiao209"></i>
                        <span class="sp-info-label">邮箱：x@clpp.org.cn</span>
                    </p>
                </div>
                <div class="company-footer-code-con clearfix">
                    <!-- <div class="f-code-img-con fl">
                        <img :src="footerLogo" alt class="f-code-img" />
                    </div> -->
                    <div class="f-code-img-con">
                        <img :src="footerCodeImg" alt class="f-code-img" />
                        <p class>中物联教育培训公众号</p>
                    </div>
                </div>
                <p class="p-footer-3">
                    <span>Copyright 版权所有 ©</span>
                    <span class="sp-info-label">北京中物联物流采购培训中心</span>
                </p>
                <p class="p-footer-4">
                    <span>备案号：</span>
                    <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19032250号-1</a>
                </p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import login from "components/login/login.vue";
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
import newLogin from "components/newLogin.vue";
import IfpsmLogin from "components/IfpsmLogin.vue";

import videoLogin from "components/videoLogin.vue";
export default {
    data() {
        return {
            certifycateList:[],
            screenWidth: document.body.clientWidth,
            showObject: {
                isShow: false,
            },
            videoShowObject: {
                isShow: false,
            },
            ifpsmShowObject:{
                isShow:false,
            },
            showPhoneMenu: false,
            show1: true,
            show2: false,
            show3: false,
            isTab: "account",
            isRoleTab: "1",
            isShow: false,
            wlxLogo: require("assets/images/logo2.png"),
            footerLogo: require("assets/images/clpp-logo-white.png"),
            footerBgImg: require("assets/images/wl-footer-img.png"),
            footerBgImg1: require("assets/images/bg-4.png"),
            defaultBannerImgList: [{
                    BannerTitle: "1",
                    imgUrl: "",
                    DocUrl: require("assets/images/certify-site-img.png"),
                },
                {
                    BannerTitle: "2",
                    imgUrl: "",
                    DocUrl: require("assets/images/fh-banner1.png"),
                },
                {
                    BannerTitle: "3",
                    imgUrl: "",
                    DocUrl: require("assets/images/certify-site-img.png"),
                },
            ],
            footImage: require("assets/images/bot2.png"),
            footerCodeImg: require("assets/images/qrcode.png"),
            scanVisible: false,
            ruleForm: {
                userName: "",
                password: "",
                phone: "",
                captcha: "",
            },
            rules: {
                userName: [{
                    required: true,
                    message: "请输入用户账号",
                    trigger: "change"
                }],
                password: [{
                    required: true,
                    message: "请输入密码",
                    trigger: "change"
                }],
                phone: [{
                    required: true,
                    message: "请输入手机号",
                    trigger: "change"
                }],
                captcha: [{
                    required: true,
                    message: "请输入验证码",
                    trigger: "change"
                }],
            },
            count: 60,
            isPhone: false,
            isShowBanner: true,
            activeIndex: 0,
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function () {
            return this.$store.state.association;
        },
        target() {
            let Urlname = "";
            if (this.$store.state.auth.userType === 1) {
                Urlname = "stuBasicInfo";
            } else if (this.$store.state.auth.userType === 2) {
                Urlname = "managerIndex";
            } else if (this.$store.state.auth.userType === 3) {
                Urlname = "siteBasicInfo";
            } else if (this.$store.state.auth.userType === 5||this.$store.state.auth.userType === 15) {
                Urlname = "managerIndex";
            } else if (this.$store.state.auth.userType === 11) {
                Urlname = "itcIndex";
            }
            return {
                name: Urlname
            };
        },
    },
    watch: {
        association: {
            handler(val) {
                document.title = val.associationName;
                this.getBanner();
                this.wlxLogo = val.Logo;
            },
            deep: true,
        },
        userInfo: {
            handler(val) {
                if (val.code > 0) {
                    this.scanVisible = false;
                }
            },
            deep: true,
        },
        $route: {
            handler: function (val, oldVal) {
                // if (val.name == "metarialCenter" || val.name == "videoDetail" || val.name == "videoChart") {
                //     this.activeIndex = 1;
                // } else {
                //     this.activeIndex = 0;
                // }
                if (val.name == "examResultQuery" || val.name == "certifyQuery" || val.name == "videoDetail" || val.name == "metarialCenter" || val.name == "videoDetail" || val.name == "videoChart" || val.name == "teachingDetails") {
                    this.isShowBanner = false;
                } else {
                    this.isShowBanner = true;
                }
            },
            // 深度观察监听
            deep: true,
        },
    },
    components: {
        newLogin,
        videoLogin,
        IfpsmLogin,
    },
    mounted() {
		if (!document.getElementById('embed-lite-bubble-image')) {
			new EmbedLiteSDK({
				appId: '093d266f-c70b-49d7-b406-456db3b57701',
				code: 'embedVucawE59DNXY7gDLGgGu',
				imageUrl: 'https://file.clpp.org.cn/ykt/ori/x2mmalko-6tl1m-yxtdsjw/WJsEbfQkxabM55Br.png'
			})
		}
		// // 创建第一个 script 标签
		// const script1 = document.createElement('script');
		// script1.src = '/public/embedLiteSDK.js';
		// script1.onload = () => {
		// 	// 第一个脚本加载完成后，创建并插入第二个脚本
		// 	const script2 = document.createElement('script');
		// 	script2.textContent = `
		// 	new EmbedLiteSDK({
		// 		appId: '093d266f-c70b-49d7-b406-456db3b57701',
		// 		code: 'embedVucawE59DNXY7gDLGgGu',
		// 		imageUrl: 'https://file.clpp.org.cn/ykt/ori/x2mmalko-6tl1m-yxtdsjw/WJsEbfQkxabM55Br.png'
		// 	});
        //     `;
		// 	document.body.appendChild(script2);
		// };
		// document.body.appendChild(script1);
	},
    created() {
        if (this.screenWidth <= 800) {
            this.isPhone = true;
        } else {
            this.isPhone = false;
        }
        //
        var that = this;
        if (localStorage["userId"] !== undefined) {
            that.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
        }
        that.$store.dispatch(MU_UPATE_SCHOOL, {
            id: window.location.href
        });
        if (this.$route.name == "metarialCenter" || this.$route.name == "videoDetail" || this.$route.name == "videoChart") {
            this.activeIndex = 1;
        } else {
            this.activeIndex = 0;
        }
        // banner 图切换
        if (this.$route.name == "examResultQuery" || this.$route.name == "certifyQuery" || this.$route.name == "videoDetail" || this.$route.name == "metarialCenter" || this.$route.name == "videoDetail" || this.$route.name == "videoChart" || this.$route.name == "teachingDetails") {
            this.isShowBanner = false;
        } else {
            this.isShowBanner = true;
        }
        this.getCerfitycateList();
    },
    methods: {
        getCerfitycateList() {
            this.$http.post("/api/XOrg/AssociationIndex/getCertificateList").then(res => {
                if (res.code > 0) {
                    this.certifycateList = res.list;
                    this.certifycateList.forEach(val => {
                        if (val.CertificateName.includes('职业')) {
                            this.$set(val, 'titleName', val.CertificateName.split('职业')[0]);
                        } else {
                            this.$set(val, 'titleName', '');
                        }
                    });
                }
            });
        },
        toMkCerfitySelect() {
            this.$router.push({
                name: 'mockCertifySelect'
            });
        },
        toPhLogin() {
            this.$router.push({
                name: "phLogin",
            });
        },
        toPhRegister() {
            this.$router.push({
                name: "phRegister",
            });
        },
        enterExam() {
            this.$message.warning("请使用电脑端操作!");
        },
        phManagerTip() {
            this.$message({
                message: "请使用电脑端进行操作!",
                type: "warning",
            });
        },
        closePhoneMenu() {
            this.showPhoneMenu = false;
        },
        hidePhoneMenu() {
            this.showPhoneMenu = false;
        },
        openPhoneMenu() {
            this.showPhoneMenu = true;
        },
        enterManager() {
            this.scanVisible = true;
            this.hidePhoneMenu();
            this.openLogin();
        },
        verificationMobile() {
            var re = /^1\d{10}$/;
            if (re.test(this.ruleForm.phone)) {} else {
                this.$message.warning("手机号格式不正确");
                return false;
            }
        },
        //验证码
        sendMessage() {
            var once = true;
            let str_ = Date.parse(new Date()) / 1000;
            let str = this.encryption(str_);
            let str1 = CryptoJS.MD5(str_ + "").toString();
            var s1 = str1.substring(0, 7);
            var s2 = str1.substring(7);
            str1 = s1 + "s" + s2;
            if (once) {
                var that = this;
                this.$http
                    .post("/api/XOrg/XLogin/sendCode", {
                        verifyInfo: this.ruleForm.phone,
                        str: str,
                        str1: str1,
                    })
                    .then((rst) => {
                        if (rst.code > 0) {
                            this.$message.success(rst.msg);
                            this.verifyCode = rst.verifyCode;
                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.count = TIME_COUNT;
                                this.show1 = false;
                                this.show2 = true;
                                this.show3 = false;
                                this.timer = setInterval(() => {
                                    if (this.count > 0 && this.count <= TIME_COUNT) {
                                        this.count--;
                                        once = false;
                                    } else {
                                        this.show1 = false;
                                        this.show2 = false;
                                        this.show3 = true;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                        once = true;
                                    }
                                }, 1000);
                            }
                        } else {
                            this.$message.warning(rst.msg);
                        }
                    });
            }
        },
        encryption: function (str) {
            let Base64 = require("js-base64").Base64;
            return Base64.encode(str);
        },
        showClick() {
            this.isShow = !this.isShow;
        },
        openLogin() {
            this.showObject = {
                isShow: true,
            };
        },
        openVideoLogin() {
            this.videoShowObject = {
                isShow: true,
            };
        },
        openIfpsmLogin() {
            this.ifpsmShowObject = {
                isShow: true,
            };
        },
        roleTab(role) {
            this.isRoleTab = role;
        },
        switchTab(content) {
            this.isTab = content;
        },
        register() {
            document.getElementsByTagName("html")[0].scrollTop = 450;
            this.$router.push({
                name: "register",
            });
        },
        goRegister() {
            this.scanVisible = false;
            this.register();
            // this.$router.push({
            //   name: 'register'
            // })
            // document.getElementsByTagName('html')[0].scrollTop  = 420;
        },
        login: function () {
            var that = this;
            this.loadingTip(true);
            this.$http
                .post("/api/XOrg/XLogin/Accountlogin", {
                    userName: that.ruleForm.userName,
                    userPwd: that.ruleForm.password,
                    associationId: that.association.Id,
                })
                .then(function (rst) {
                    if (rst && rst.code > 0) {
                        if (rst.code === 1) {
                            localStorage["userName"] = that.ruleForm.userName;
                            localStorage["userId"] = rst.userId;
                        }
                        that.$store.dispatch(MU_UPATE_AUTH).then((rt) => {
                            that.loadingTip(false);
                            // 登录完获取回登录信息跳转
                            that.scanVisible = false;
                        });
                    } else {
                        that.loadingTip(false);
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //手机登录
        Phonelogin() {
            var that = this;
            this.loadingTip(true);
            this.$http
                .post("/api/XOrg/XLogin/Phonelogin", {
                    phone: that.ruleForm.phone,
                    captcha: that.ruleForm.captcha,
                    associationId: that.association.Id,
                })
                .then((rst) => {
                    if (rst && rst.code > 0) {
                        if (rst.code === 1) {
                            localStorage["userName"] = that.ruleForm.userName;
                            localStorage["userId"] = rst.userId;
                        }
                        that.$store.dispatch(MU_UPATE_AUTH).then((rt) => {
                            that.loadingTip(false);
                            // 登录完获取回登录信息跳转
                            that.scanVisible = false;
                        });
                    } else {
                        that.loadingTip(false);
                        that.$message.warning(rst.msg);
                    }
                });
        },
        loadingTip(is) {
            // let loading = null;
            if (is) {
                this.$loading({
                    lock: true,
                    text: "正在登录...",
                });
            } else {
                this.$loading({}).close();
            }
        },
        getBanner() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationIndex/getBanner", {
                    associationId: that.association.Id,
                })
                .then(function (rst) {
                    if (rst.bannerList.length > 0) {
                        that.defaultBannerImgList = rst.bannerList;
                    }
                });
        },
        outLogin() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/outLogin").then(function (rst) {
                if (rst.code > 0) {
                    that.$store.commit(MU_UPATE_AUTH, null);
                    that.$router.push({
                        name: "xHome"
                    });
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
        enterRegister() {
            this.scanVisible = false;
            this.$router.push({
                name: "register",
            });
        },
        schoolApplyCert(){
          let userInfo=this.$store.state.auth;
          if(userInfo&&userInfo.userId)
          {
            if(userInfo.userType==11)
            {
                this.$router.push({
                name: 'itcBatch'
            });
            }else{
                this.$message.warning("当前账号没有院校集体申请国际证书权限，请使用试点院校管理员账号登录!");
            }
       
          }else{
            this.openLogin();
          }
        },
        personalApplyCert(){
            this.openIfpsmLogin();
        },
    },
};
</script>
